import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Spin, message } from 'antd';


import RightImageComponent from './right_image_component'
import AuthFooterComponent from './footer_component'
import AuthenticationService from '../../service/authentication_service';
import AppService from '../../service/app_service';

class VerifyEmailPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dashboard: props.dashboard,
            token: props.match.params.token,
            loading: false
        };
    }

    componentDidMount() {
        this.verifyEmailAddress();
    }

    logout = () => {
        AuthenticationService.clearLocalstorage();
    }

    verifyEmailAddress = () => {
        this.setState({ loading: true });

        AppService.verifyEmailAddress(this.state).then(rec => {
            if (rec) {
                if (rec.code === "400") {
                    message.error(rec.message);
                    this.setState({ loading: false });
                } else {
                    message.success("Email Verification successful.")
                    this.props.history.push("/signin");
                }
            } else {
                message.error("Empty response")
            }
        })
    }

    render() {
        const { loading } = this.state;
        return (
            <Spin spinning={loading}>
                <div className="page-ath-wrap">

                    <div className="page-ath-content">
                        <div className="page-ath-header"><a href="/" className="page-ath-logo"><img src="/assets/images/logo.png" srcSet="/assets/images/logo2x.png 2x" alt="logo" /></a></div>
                        <div className="page-ath-form">
                            <h2 className="page-ath-heading">Email Verification</h2>
                            <span>Verification of email is one step into verifying that you are a human.</span>

                        </div>
                        <AuthFooterComponent />
                    </div>

                    <RightImageComponent image="https://img.icons8.com/bubbles/2x/email.png" />
                </div>
            </Spin>
        );
    }
}

export default withRouter(VerifyEmailPage);
